import { useMemo } from 'react'
import { useExecuteQueryBlueprintQuery } from '../../../../api/denali'
import { useParameterReplacementEx } from '../../../../hooks/useAbundanceEngineParameters'
import { useVariables } from '../../../../providers/VariableProvider'

const EMPTY_ARRAY = []

/**
 * Executes a blueprint purpose and returns the result.
 * Applies abundance engine parameter substitution to the provided parameters.
 */
export default function useBlueprintData (blueprintCode, purposeCode, options = {}) {
  const {
    parameters = {},
    page,
    pageSize,
    sortBy,
    sortDirection,
    subordinatePredicates,
    filters,
    includeCount,
    scopePredicates
  } = options

  const { variables } = useVariables()
  const [resolvedParams] = useParameterReplacementEx(parameters, variables)

  const request = useMemo(() => {
    if (!blueprintCode || !purposeCode) return null

    const req = {
      code: blueprintCode,
      purposeCode,
      parameters: resolvedParams
    }

    if (page !== undefined) req.page = page
    if (pageSize !== undefined) req.pageSize = pageSize
    if (sortBy) {
      req.sortBy = sortBy
      if (sortDirection) req.sortDirection = sortDirection
    }
    if (subordinatePredicates?.length) req.subordinatePredicates = subordinatePredicates
    if (filters?.length) req.filters = filters
    if (includeCount) req.includeCount = true
    if (scopePredicates?.length) req.scopePredicates = scopePredicates

    return req
  }, [blueprintCode, purposeCode, resolvedParams, page, pageSize, sortBy, sortDirection, subordinatePredicates, filters, includeCount, scopePredicates])

  const { data, isLoading, isFetching, error } = useExecuteQueryBlueprintQuery(request, {
    enabled: !!request
  })

  return {
    data: data?.data ?? EMPTY_ARRAY,
    metadata: data?.metadata ?? null,
    isLoading,
    isFetching,
    error
  }
}
